const gtmDataLayer = {
  install: (app) => {
    const gtm = {
      sendAiTalkButtonEvent() {
        window.dataLayer.push({
          event: 'ai-talk-button',
          tagCategory: 'ai-talk-btn'
        });
      },

      sendNewsDetailCategories(industry = 'defaultIndustry', region = 'defaultRegion') {
        let normalizedIndustry = this.normalizeIndustryCategory(industry);
        let normalizedRegion = this.normalizeRegionCategory(region);

        window.dataLayer.push({
          event: 'news-detail',
          tagCategory: 'news-detail',
          newsIndustry: normalizedIndustry,
          newsRegion: normalizedRegion,
        });
      },

      sendAiTalkIndustryCategory(industry = 'defaultIndustry', relationship = 'defaultRelationship') {
        let normalizedIndustry = this.normalizeIndustryCategory(industry);
        
        window.dataLayer.push({
          event: 'ai-gen-industry',
          tagCategory: 'ai-gen-industry',
          newsIndustry: normalizedIndustry,
          relationship: relationship,
        });
      },

      sendAiTalkRegionCategory(region = 'defaultRegion', relationship = 'defaultRelationship') {
        let normalizedRegion = this.normalizeRegionCategory(region);

        window.dataLayer.push({
          event: 'ai-gen-region',
          tagCategory: 'ai-gen-region',
          newsRegion: normalizedRegion,
          relationship: relationship,
        });
      },

      sendSearchWords(searchWords = 'defaultSearchWords') {
        window.dataLayer.push({
          event: 'search-news',
          tagCategory: 'search-news',
          searchWords: searchWords,
        });
      },

      normalizeIndustryCategory(industry) {
        const strIndustry = industry?.toString() ?? '';
        
        if (strIndustry.trim() === '') {
          return '(業界カテゴリなし)';
        }
        return strIndustry;
      },

      normalizeRegionCategory(region) {
        const strRegion = region?.toString() ?? '';
        
        if (strRegion.trim() === '') {
          return '全国';
        }
        return strRegion;
      }
    };

    // provide を使ってグローバルに `$gtm` を提供
    app.provide('$gtm', gtm);
  }
};

export default gtmDataLayer;
